import { render, staticRenderFns } from "./BrandsCarousel.vue?vue&type=template&id=be1dd37e"
import script from "./BrandsCarousel.vue?vue&type=script&lang=js"
export * from "./BrandsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandCarousel: require('/opt/build/repo/components/brand/Carousel.vue').default,SectionBase: require('/opt/build/repo/components/section/Base.vue').default})
